import styled from 'styled-components';

import PlainLink from './PlainLink';

import EXTERNAL_LINK_LIGHT_ICON from '../images/ic-external-link-light.svg';
import EXTERNAL_LINK_DARK_ICON from '../images/ic-external-link-blue.svg';

const PlainExternalLink = styled(PlainLink).attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  &::after {
    content: '';
    height: 1em;
    width: 1em;
    /* stylelint-disable */
    background-image: url('${props =>
      props.isLight ? EXTERNAL_LINK_LIGHT_ICON : EXTERNAL_LINK_DARK_ICON}');
    /* stylelint-enable */
    background-repeat: no-repeat;
    display: inline-block;
    margin-right: ${props => props.theme.spacing(1)};
    margin-left: ${props => props.theme.spacing(1)};
    vertical-align: bottom;
  }
`;

export default PlainExternalLink;
